import styled from 'styled-components';

export const ConfigureHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const ConfigureIcon = styled.img`
  width: 20px;
  height: 20px;
`;

export const ConfigureTitle = styled.p`
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #212529;
`;

export const ConfigureDescription = styled.p`
  margin-top: 8px;
  font-size: 14px;
  font-weight: 400;
  color: #6c757d;
`;

export const ChannelCell = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const ChannelColor = styled.div`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: ${({ $color }) => $color};
`;
